import { motion } from "framer-motion";
import { ISACK_AVATAR, EXPERIENCES } from "@/lib/media";

export const OrbitingUniverse = ({ onSelect }) => {
  // Two rings for depth
  const rings = [
    { radius: 230, items: EXPERIENCES.slice(0, 4), duration: 90, size: 88 },
    { radius: 360, items: EXPERIENCES.slice(4), duration: 130, size: 76 },
  ];

  return (
    <div
      className="relative flex items-center justify-center w-full h-full select-none"
      data-testid="orbiting-universe"
    >
      {/* Ambient orbit rings */}
      {rings.map((r, i) => (
        <div
          key={`ring-${i}`}
          className="absolute rounded-full border border-gold/10"
          style={{ width: r.radius * 2, height: r.radius * 2 }}
          aria-hidden="true"
        />
      ))}

      {/* Central Sun — Isack */}
      <div className="absolute flex flex-col items-center z-20">
        <motion.div
          className="relative rounded-full gold-glow animate-sun-pulse"
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.1, ease: "easeOut" }}
        >
          <div className="absolute -inset-3 rounded-full bg-gold/20 blur-2xl" aria-hidden="true" />
          <img
            src={ISACK_AVATAR}
            alt="Isack, your Sadara concierge"
            className="relative w-36 h-36 md:w-44 md:h-44 rounded-full object-cover border-2 border-gold/60"
            data-testid="isack-sun-avatar"
          />
        </motion.div>
        <div className="mt-4 text-center">
          <p className="text-xs tracking-[0.3em] uppercase text-gold/70">Your Concierge</p>
          <p className="font-display text-2xl text-foreground">Isack</p>
        </div>
      </div>

      {/* Orbiting rings of experiences */}
      {rings.map((ring, ri) => (
        <div
          key={`orbit-${ri}`}
          className="orbit-ring absolute"
          style={{ width: ring.radius * 2, height: ring.radius * 2, animationDuration: `${ring.duration}s` }}
        >
          {ring.items.map((exp, idx) => {
            const angle = (idx / ring.items.length) * 2 * Math.PI;
            const x = ring.radius + ring.radius * Math.cos(angle) - ring.size / 2;
            const y = ring.radius + ring.radius * Math.sin(angle) - ring.size / 2;
            return (
              <button
                key={exp.key}
                type="button"
                className="orbit-counter absolute group"
                style={{ left: x, top: y, width: ring.size, height: ring.size, animationDuration: `${ring.duration}s` }}
                onClick={() => onSelect(exp.prompt)}
                data-testid={`planet-${exp.key.toLowerCase().replace(/\s+/g, "-")}`}
                title={exp.label}
              >
                <span className="block w-full h-full rounded-full overflow-hidden border border-gold/40 shadow-lg shadow-black/50 transition-[border-color,box-shadow,transform] duration-300 group-hover:scale-110 group-hover:border-gold group-hover:shadow-gold/30">
                  <img src={exp.img} alt={exp.label} className="w-full h-full object-cover" />
                </span>
                <span className="pointer-events-none absolute -bottom-6 left-1/2 -translate-x-1/2 whitespace-nowrap text-[11px] tracking-wide text-gold/50 group-hover:text-gold transition-colors">
                  {exp.label}
                </span>
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
};
